import api from "../store/services/api";

class ChannelsService {
  channelReport = async (params = null) => {
    return api.get("/new/platform-data/", {
      params,
    });
  };
  channelAverageOrderTotal = async (params = null) => {
    return api.get("/new/platform-data/average/total/", {
      params,
    });
  };
}

export default new ChannelsService();
